import React from "react";

const Background = ({ children }) => {
  return (
    <div className="banner">
      {children}
    </div>
  )
}

export default Background;